import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import { Button } from '@/components/ui/button';
import { TotadminPermission } from 'data/__generated__';
import { PageActions, PageBreadcrumb, PageBreadcrumbSegment, PageHeader } from 'components/PageHeader';
import { SitesList } from './components/SitesList';

export const Sites = () => {
    return (
        <Container>
            <Helmet title="Sites · TOTADMIN" />
            <PageHeader>
                <PageBreadcrumb>
                    <PageBreadcrumbSegment label="Sites" isCurrent />
                </PageBreadcrumb>
                <PageActions>
                    <Button size="sm" variant="outline" asChild requiredPermissions={[TotadminPermission.SitesManage]}>
                        <Link to="/site/imports">Imports CSV</Link>
                    </Button>
                    <Button size="sm" asChild requiredPermissions={[TotadminPermission.SitesManage]}>
                        <Link to="/site/create">Créer un site</Link>
                    </Button>
                </PageActions>
            </PageHeader>
            <Content>
                <ListContainer>
                    <SitesList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    padding: 15px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
